import request from '@/utils/request'

export function getSignList(query) {
  return request({
    url: '/hfsign/list',
    method: 'get',
    params: query
  })
}

export function batchSign(signList) {
  return request({
    url: '/hfsign/batch',
    method: 'post',
    data: { signList }
  })
}

export function checkSigned(processId) {
  return request({
    url: '/hfsign/check',
    method: 'get',
    params: { processId }
  })
}

// 企业微信 code 直登（企业微信内打开应用 URL 自带 code）
export function qwLogin(params) {
  return request({
    url: '/hfsign/oauth/qw-login',
    method: 'get',
    params: params
  })
}

// 飞书 code 登录（跳飞书授权页回跳后带 code）
export function feishuLogin(params) {
  return request({
    url: '/hfsign/oauth/feishu-login',
    method: 'get',
    params: params
  })
}